var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "kpi-d" },
    _vm._l(_vm.chartData, function (kpiDData, kpiDIndex) {
      return _c("div", { key: kpiDIndex, staticClass: "flex-row flex-1" }, [
        _c("div", { staticClass: "flex-col flex-1 mr-2 ml-1" }, [
          _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
            _vm._v(" " + _vm._s(kpiDData.kpiNameLabel) + " "),
          ]),
          _c("div", { staticClass: "flex-row flex-1 flex-align-center mb-1" }, [
            _vm._v(
              " " +
                _vm._s(kpiDData.typeDLabel1) +
                " " +
                _vm._s(_vm.performanceValue) +
                " "
            ),
          ]),
          _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
            _vm._v(" " + _vm._s(kpiDData.typeDLabel2) + " "),
          ]),
        ]),
        _c("div", { staticClass: "flex-col flex-3" }, [
          _c(
            "div",
            { staticClass: "flex-row flex-1 flex-align-center chart-title" },
            [_vm._v(" " + _vm._s(kpiDData.kpiName) + " ")]
          ),
          _c(
            "div",
            { staticClass: "flex-row flex-1 flex-justify-center perf-block" },
            [
              _c("div", { staticClass: "flex-col flex-4 box-side-label" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("struggleWithUnambitiousTargets")) + " "
                ),
              ]),
              _c("div", { staticClass: "flex-col flex-2 ml-1 redBox" }, [
                _vm.performanceBlock.isRedMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "flex-col flex-2 yellowBox" }, [
                _vm.performanceBlock.isYellowMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "flex-col flex-2 darkGreenBox" }, [
                _vm.performanceBlock.isDarkGreenMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "flex-col flex-2 lightGreenBox" }, [
                _vm.performanceBlock.isLightGreenMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "flex-col flex-2 mr-2 greenBox" }, [
                _vm.performanceBlock.isGreenMarked
                  ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                  : _vm._e(),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "flex-col flex-4 flex-justify-center mr-4 pr-4 box-side-label",
                },
                [_vm._v(" " + _vm._s(_vm.$t("exceedAmbitiousTarget")) + " ")]
              ),
            ]
          ),
          _c("div", { staticClass: "flex-row flex-1 risk-block" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex-col flex-4 flex-align-center pt-1 box-side-label",
              },
              [_vm._v(" " + _vm._s(_vm.$t("underMaintained")) + " ")]
            ),
            _c("div", { staticClass: "flex-col flex-2 ml-1 redBox" }, [
              _vm.riskBlock.isRedMarked
                ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "flex-col flex-2 yellowBox" }, [
              _vm.riskBlock.isYellowMarked
                ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "flex-col flex-2 darkGreenBox" }, [
              _vm.riskBlock.isDarkGreenMarked
                ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "flex-col flex-2 lightGreenBox" }, [
              _vm.riskBlock.isLightGreenMarked
                ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "flex-col flex-2 mr-2 greenBox" }, [
              _vm.riskBlock.isGreenMarked
                ? _c("span", [_vm._v(_vm._s(_vm.cross))])
                : _vm._e(),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "flex-col flex-4 flex-justify-center pt-1 mr-4 pr-4 box-side-label",
              },
              [_vm._v(" " + _vm._s(_vm.$t("wellMaintained")) + " ")]
            ),
          ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }